import { toggleClass } from '../tools/helpers';

// cards
document.querySelectorAll('.card:not(.card--static):not(.card--link)').forEach((card) => {
  card.addEventListener('click', (evt) => {
    toggleClass(evt.currentTarget, 'card--active');
  });
});



// WEBPACK FOOTER //
// ./src/javascript/main/cards.js